<template>
    <div v-if="childCategories.length > 0" class="support-categories-card__content" title="Has sub-menu" @click="onEnterCategory(currentCategory, childCategories)">
        <img :src="imageUrl" :alt="imageAlt" class="support-categories-card__img">
        <p class="support-categories-card__copy">{{displayTitle}}</p>
        <div class="support-categories-card__icon">
            <span class="icon-bullet-list"></span>
        </div>
    </div>

    <div class="support-categories-card__content support-categories-card__content--link" v-else>
        <a :href="'support/troubleshooting/category/' + urlName" target="_blank" :alt="displayTitle" class="support-categories-card__link">
            <img :src="imageUrl" :alt="imageAlt" class="support-categories-card__img">
            <p class="support-categories-card__copy">{{displayTitle}}</p>
        </a>
    </div>
</template>

<script lang="ts">
    export default {
        name: "SupportCategoriesCard",
        props: {
            displayTitle: {
                type: String,
                default: ""
            },
            imageUrl: {
                type: String,
                default: ""
            },
            imageAlt: {
                type: String,
                default: ""
            },
            childCategories: {
                type: Array,
                default: []
            },
            onEnterCategory: {
                type: Function,
                default: null
            },
            currentCategory: {
                type: Array,
                default: []
            },
            urlName: {
                type: String,
                default: ""
            }
        }
    };
</script>